import React from "react";
import GenericMandatoryInput from "../GenericMandatoryInput";
import { CommonInputProps } from "./models";

const AddressLineInput = (props: CommonInputProps) => {
  return <GenericMandatoryInput
    {...props}
    title={RESX.Address.resxAddress}
    maxLength={serverReference.constants.address.maxAddressLineLength}
  />;
};

export default AddressLineInput;